import HorizontalInfoGraph from './HorizontalInfoGraph'

export default HorizontalInfoGraph
